var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / COC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19BFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ACAC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-COC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3333333,17.3333333 L18.9073486,17.759318 C18.7744236,17.892243 18.5625,17.8958333 18.4259847,17.759318 L18,17.3333333 L19.3333333,17.3333333 Z M17.6635437,2.66666667 C17.8493634,2.66666667 18.0759601,2.79326693 18.1705188,2.95086479 L19.829481,5.71580187 C19.923656,5.87276017 20.0827321,6.1240983 20.1832907,6.2749362 L22.4833757,9.7250638 C22.5846044,9.87690687 22.6666665,10.1433716 22.6666665,10.3269857 L22.6666664,12.339681 C22.6666664,12.5202702 22.5839342,12.790765 22.4833756,12.9416029 L20.1832905,16.3917305 C20.0820618,16.5435735 19.8566282,16.6666667 19.6730141,16.6666667 L17.6603187,16.6666667 C17.4797295,16.6666667 17.2179347,16.5705013 17.0708819,16.4479574 L13.5957842,13.5520426 C13.4508365,13.4312528 13.1899615,13.3333333 13.0063474,13.3333333 L10.9936521,13.3333333 C10.8130629,13.3333333 10.5335792,13.3998769 10.3660163,13.4836584 L6.96731665,15.1830083 C6.80127218,15.2660305 6.56204212,15.2287089 6.43441762,15.1010844 L5.56558228,14.2322489 C5.43731474,14.1039814 5.33333336,13.8430634 5.33333336,13.6697407 L5.33333336,12.3302593 C5.33333336,12.1478621 5.24584963,11.8687744 5.14793905,11.7219086 L4.18539418,10.2780914 C4.08300373,10.1245058 4.06430932,9.87138112 4.15295017,9.69409943 L5.18038306,7.63923391 C5.26485518,7.47028969 5.46195224,7.2690239 5.63923394,7.18038305 L7.69409945,6.15295029 C7.86304368,6.06847818 8.1433716,5.9641571 8.32698568,5.91825358 L10.3396809,5.41507975 C10.5202701,5.36993245 10.7812499,5.24739583 10.9321059,5.13425382 L13.0678938,3.53241285 C13.1851723,3.44445398 13.3836448,3.36981841 13.5498426,3.34348254 L13.6666665,3.33333333 C13.8507614,3.33333333 14.0663597,3.46605301 14.1479548,3.62924321 L14.5187116,4.37075679 C14.6004248,4.5341833 14.8236032,4.66666667 14.9969258,4.66666667 L16.3364072,4.66666667 C16.5188044,4.66666667 16.7330264,4.53394699 16.8146215,4.37075679 L17.1853782,3.62924321 C17.2670915,3.4658167 17.2291665,3.22916667 17.0926513,3.09265137 L16.9073486,2.90734863 C16.7744236,2.77442365 16.8093567,2.66666667 17.0031229,2.66666667 L17.6635437,2.66666667 Z",
    id: "Rectangle-1078",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoc);
export default __webpack_public_path__ + "static/media/COC.88e5a48174ee82946a6cb373a6bae525.svg";
export { ForwardRef as ReactComponent };